import { React, useState, useEffect } from "react";
import images from "../../../images.config";
import icons from "../../../icons.config";
import { IMAGE_BASE_URL } from "../../../api-urls";

const Founder = ({ data }) => {
  // Extract data from the received prop (assuming it comes from an API or state)
  const {
    content_images = [],
    name_title = "Default Title",
    name_title_color = "white",
    title_description = "Default Description",
    title_description_color = "white",
  } = data || {};

  // Convert image paths into an array with original and grayscale versions
  const imageList = content_images.map((img) => ({
    original: img,
    gImage: img, // Replace with a grayscale version if needed
  }));

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  const updateImages = () => {
    setIsFading(true); // Start fading
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList.length);
      setIsFading(false); // End fading
    }, 500);
  };

  useEffect(() => {
    if (imageList.length > 0) {
      const interval = setInterval(updateImages, 3000);
      return () => clearInterval(interval);
    }
  }, [imageList]);
 

  return (
    <section className="relative bg-primary2 pt-[5%] pb-[40%] md:py-[12%] lg:py-0 z-1 bottom-0 md:px-8 xl:px-2 overflow-hidden">
      {/* Pattern Overlay */}
      <div
        className="absolute inset-0 z-10 bg-cover h-[90%] bg-center pointer-events-none overflow-hidden"
        style={{
          backgroundImage: `url(${icons.brandPattern})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          top: "4%",
          left: "3%",
          right: "3%",
          bottom: "4%",
          width: "94%",
          height: "92%",
        }}
      />
      <div className="relative top-16 md:top-12 lg:top-0">
        <h3
          className="text-xl md:text-3xl lg:hidden flex justify-center font-outfit font-light mb-4 relative bottom-5 md:bottom-12"
          style={{ color: `#${name_title_color}` }}
        >
          {name_title}
        </h3>

        {/* Image for small screens */}
        {imageList.length > 0 && (
          <div className="flex justify-center items-center lg:hidden z-20">
            <img
              src={IMAGE_BASE_URL+imageList[currentIndex]?.original}
              alt="Founder"
              className="w-[77%] md:w-[95%] h-auto object-cover animate-dissolve relative transition-opacity duration-500"
              onError={(e) => console.error("Image failed to load:", e.target.src)}
            />
          </div>
        )}

        {/* Content Section */}
        <div className="container relative mx-auto px-3 flex flex-col lg:flex-row items-center z-20 mt-16 lg:mt-0 xl:mt-16 xl:mb-16 2xl:mt-6 2xl:mb-6">
          {/* Text Section */}
          <div className="lg:w-1/2 text-center relative lg:left-28">
            <h3
              className="text-xl hidden lg:block lg:text-3xl justify-center font-outfit font-light mb-10"
              style={{ color: `#${name_title_color}` }}
            >
              {name_title}
            </h3>
            <h2 className="text-3xl md:text-5xl lg:text-5xl font-outfit font-medium text-white mb-12">
              JIYA BENIWAL
            </h2>
            <h5
              className="text-md font-poppins font-medium mb-4 px-4 md:px-0"
              style={{ color: `#${title_description_color}` }}
            >
              {title_description}
            </h5>
            <p className="font-poppins font-light text-hcolor text-sm md:text-base px-5 lg:px-0">
              Our mission is to provide premium, customizable fit that empowers
              everyone to express their unique identity and style while enjoying
              the luxury of exquisite fits and premium fabrics.
            </p>
          </div>

          {/* Image Section for Larger Screens */}
          {imageList.length > 0 && (
            <div className="grid grid-cols-2 gap-4 w-full max-w-5xl mx-auto lg:relative lg:top-12 lg:left-28 md:pr-0 lg:pr-[8%] xl:pr-[3%]">
              <div className="col-span-1 justify-center hidden lg:flex z-10">
                <img
                  src={IMAGE_BASE_URL+imageList[currentIndex].original}
                  alt="Founder"
                  className={`w-[65%] h-[95%] object-cover transition-opacity duration-500 ${
                    isFading ? "opacity-0" : "opacity-100"
                  } relative left-32 top-6`}
                />
                 
              </div>

              <div className="col-span-1 hidden lg:flex">
                <img
                  src={
                    imageList.length > 1
                      ? IMAGE_BASE_URL+imageList[(currentIndex + 1) % imageList.length].gImage
                      : IMAGE_BASE_URL+imageList[currentIndex].original
                  }
                  alt="Founder"
                  className={`w-[65%] h-[95%] object-cover transition-opacity duration-500 ${
                    isFading ? "opacity-0" : "opacity-100"
                  } relative right-4 bottom-4`}
                />
              </div>

              <div className="col-span-2 justify-center hidden lg:flex">
                <img
                  src={
                    imageList.length > 2
                      ? IMAGE_BASE_URL+imageList[(currentIndex + 2) % imageList.length].gImage
                      : IMAGE_BASE_URL+imageList[currentIndex].original
                  }
                  alt="Founder"
                  className={`w-[33%] h-[90%] object-cover transition-opacity duration-500 ${
                    isFading ? "opacity-0" : "opacity-100"
                  } relative bottom-16 left-12`}
                  onError={(e) => console.error("Image failed to load:", e.target.src)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Founder;



// import {React,useState,useEffect} from 'react';
// import images from '../../../images.config';
// import icons from "../../../icons.config";

// const Founder = () => {
//   const imageList = [
//     { original: images.founder1, gImage: images.founder1g },
//      { original: images.founder2, gImage: images.founder2g },
//      { original: images.founder3, gImage: images.founder3g },
//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isFading, setIsFading] = useState(false);

//   const updateImages = () => {
//     setIsFading(true); // Start fading

//     setTimeout(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList.length);
//       setIsFading(false); // End fading
//     }, 500); // Duration of the fade effect
//   };

//   useEffect(() => {
//     const interval = setInterval(updateImages, 3000); // Change every 3 seconds
//     return () => clearInterval(interval);
//   }, []);
//   return (
//     <section className="relative bg-primary2 pt-[5%] pb-[40%] md:py-[12%] lg:py-0 z-1 bottom-0 md:px-8 xl:px-2 overflow-hidden">
      
//       {/* Pattern Overlay */}
//       <div
//         className="absolute inset-0 z-10 bg-cover h-[90%] bg-center pointer-events-none overflow-hidden "
//         style={{
//           backgroundImage: `url(${icons.brandPattern})`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           top: '4%',
//           left: '3%',
//           right: '3%',
//           bottom: '4%',
//           width: '94%',
//           height: '92%',
         
//         }}
//       />
//       <div className='relative top-16 md:top-12 lg:top-0'>
//       <h3 className='text-xl md:text-3xl lg:hidden flex  justify-center font-outfit font-light mb-4 text-hcolor relative bottom-5 md:bottom-12 '>THE VISIONARY BEHIND DIKOST</h3>
//        {/* Centered image for small and medium screens - shows only one image */}
//        <div className=" flex justify-center items-center lg:hidden z-20">
//             <img
//               src={imageList[currentIndex].original} // Show the original image for small screens
//               alt="Founder Image"
//               className="w-[77%] md:w-[95%] h-auto object-cover animate-dissolve relative transition-opacity duration-500"
//             />
//           </div>
//       {/* Content Section */}
//       <div className="container relative mx-auto px-3 flex flex-col lg:flex-row items-center z-20 mt-16 lg:mt-0 xl:mt-16 xl:mb-16 2xl:mt-6 2xl:mb-6">
//         {/* Text Section */}
//         <div className="lg:w-1/2 text-center relative lg:left-28 ">
//         <h3 className='text-xl hidden lg:block lg:text-3xl justify-center font-outfit font-light mb-10 text-hcolor text-nowrap'>THE VISIONARY BEHIND DIKOST</h3>
//           <h2 className="text-3xl md:text-5xl lg:text-5xl font-outfit font-medium text-white mb-12">JIYA BENIWAL</h2>
//           <h5 className="text-md font-poppins font-medium mb-4 text-white px-4 md:px-0">“Celebrate Individuality with Sophistication and Style”</h5>
//           <p className="font-poppins font-light text-hcolor text-sm md:text-base    lg:px-0 px-5 ">
//           Our mission is to provide premium, customizable fit that empowers everyone to express their unique identity and style while enjoying the luxury of exquisite fits and premium fabrics. We ensure that Dikost makes you feel comfortable first and confident next .
//           </p>
//         </div>

//        {/* Images Section (Triangular Layout) */}
//        <div className="grid grid-cols-2 gap-4 w-full max-w-5xl mx-auto lg:relative lg:top-12 lg:left-28 md:pr-0 lg:pr-[8%] xl:pr-[3%]">
//             {/* First Image */}
//             <div className="col-span-1 justify-center hidden lg:flex z-10">
//               <img
//                 src={imageList[currentIndex].original} // Show original image
//                 alt="Founder Image"
//                 className={`w-[65%] h-[95%] object-cover transition-opacity duration-500 ${
//                   isFading ? 'opacity-0' : 'opacity-100'
//                 } relative left-32 top-6`}
//               />
//             </div>

//             {/* Second Image */}
//             <div className="col-span-1 hidden lg:flex">
//               <img
//                 src={imageList[(currentIndex + 1) % imageList.length].gImage} // Show grayscale image
//                 alt="Founder Image"
//                 className={`w-[65%] h-[95%] object-cover transition-opacity duration-500 ${
//                   isFading ? 'opacity-0' : 'opacity-100'
//                 } relative right-4 bottom-4`}
//               />
//             </div>

//             {/* Third Image */}
//             <div className="col-span-2 justify-center hidden lg:flex">
//               <img
//                 src={imageList[(currentIndex + 2) % imageList.length].gImage} // Show grayscale image
//                 alt="Founder Image"
//                 className={`w-[33%] h-[90%] object-cover transition-opacity duration-500 ${
//                   isFading ? 'opacity-0' : 'opacity-100'
//                 } relative bottom-16 left-12`}
//               />
//             </div>
//           </div>
         
//         </div>
//       </div>
      
//     </section>
//   );
// };

// export default Founder;

// import React, { useEffect, useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import icons from '../../icons.config';
// import images from '../../images.config';

// const Founder = () => {
//   const imageList = [
//     { original: images.founder1, gImage: images.founder1g },
//     { original: images.founder2, gImage: images.founder2g },
//     { original: images.founder3, gImage: images.founder3g },
//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);

//   // Function to change the image index
//   const updateImages = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList.length);
//   };

//   // Change images every 3 seconds
//   useEffect(() => {
//     const intervalId = setInterval(updateImages, 3000); // Change images every 3 seconds
//     return () => clearInterval(intervalId); // Clear interval on component unmount
//   }, []);

//   return (
//     <section className="relative bg-primary2 py-16 z-1 top-32 overflow-hidden">
//       {/* Pattern Overlay */}
//       <div
//         className="absolute inset-0 z-10 bg-cover bg-center pointer-events-none"
//         style={{ backgroundImage: `url(${icons.brandPattern})` }}
//       />

//       {/* Content Section */}
//       <div className="container relative mx-auto px-4 flex flex-col lg:flex-row items-center z-20">
//         {/* Text Section */}
//         <div className="lg:w-1/2 text-center ">
//           <h3 className='text-3xl flex justify-center font-outfit font-light mb-4 text-hcolor '>THE VISIONARY BEHIND DIKOST</h3>
//           <h2 className="text-4xl font-outfit font-medium text-white mb-7">JIYA BENIWAL</h2>
//           <h5 className="text-md font-poppins font-medium mb-4 text-white">“Celebrate Individuality with Sophistication and Style”</h5>
//           <p className="font-poppins font-light text-hcolor px-12">
//             Our mission is to provide premium, customizable fit that empowers everyone to express their unique identity and style while enjoying the luxury of exquisite fits and premium fabrics. We ensure that Dikost makes you feel comfortable first and confident next.
//           </p>
//         </div>

//         {/* Images Section (Triangular Layout) */}
//         <div className="grid grid-cols-2 gap-4 w-full max-w-lg mx-auto relative top-12">
//           {/* First Image (Top Left) */}
//           <div className="col-span-1 flex justify-center z-10">
//             <AnimatePresence>
//               <motion.img
//                 key={currentIndex}
//                 src={imageList[currentIndex].original}
//                 alt='Founder 1'
//                 className="w-full h-auto object-cover"
//                 initial={{ opacity: 0 }} // Initial state
//                 animate={{ opacity: 1 }} // Animate in
//                 exit={{ opacity: 0 }} // Animate out
//                 transition={{ duration: 1.5 }} // Slow dissolving effect
//               />
//             </AnimatePresence>
//           </div>

//           {/* Second Image (Top Right) */}
//           <div className="col-span-1 flex justify-center">
//             <AnimatePresence>
//               <motion.img
//                 key={(currentIndex + 1) % imageList.length} // Use modulo for next image
//                 src={imageList[(currentIndex + 1) % imageList.length].original} // Show the next image
//                 alt='Founder 2'
//                 className="w-full h-auto object-cover"
//                 initial={{ opacity: 0 }} // Initial state
//                 animate={{ opacity: 1 }} // Animate in
//                 exit={{ opacity: 0 }} // Animate out
//                 transition={{ duration: 1.5 }} // Slow dissolving effect
//               />
//             </AnimatePresence>
//           </div>

//           {/* Third Image (Centered below the first two) */}
//           <div className="col-span-2 flex justify-center">
//             <AnimatePresence>
//               <motion.img
//                 key={(currentIndex + 2) % imageList.length} // Use modulo for next image
//                 src={imageList[(currentIndex + 2) % imageList.length].original} // Show the next image
//                 alt='Founder 3'
//                 className="w-[50%] h-auto object-cover"
//                 initial={{ opacity: 0 }} // Initial state
//                 animate={{ opacity: 1 }} // Animate in
//                 exit={{ opacity: 0 }} // Animate out
//                 transition={{ duration: 1.5 }} // Slow dissolving effect
//               />
//             </AnimatePresence>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Founder;
